import { FlashsuiteMenu } from "../components/FlashsuiteMenu";
import { GroupedList, ListRow } from "../components/season/GroupedList";
import { type SeasonLayout, useLayout } from "../components/season/layout";
import { Page } from "../components/season/Page";
import { PageHead } from "../components/season/PageHead";
import { Pane, Panes } from "../components/season/Panes";
import { cx } from "../components/ui/cx";
import { useSending } from "../sending/SendingContext";
import { sendingNavDot } from "../sending/sendingProtection";
import { SettingsRows } from "../settings/SettingsRows";
import "../styles/season-more.css";

/** Assets, Automations and Settings: the places the five tabs do not hold. */
function MoreRows({ selected = false }: { selected?: boolean }) {
  const { status } = useSending();
  const navDot = status ? sendingNavDot(status.state) : null;
  return (
    <GroupedList>
      <ListRow icon="fold" title="Assets" to="/assets" />
      <ListRow icon="zap" title="Automations" to="/automations" />
      <ListRow
        icon="sliders"
        title="Settings"
        to="/settings"
        on={selected}
        end={navDot ? <span className={cx("navdot", navDot)} aria-label="Sending needs a look" /> : undefined}
      />
    </GroupedList>
  );
}

/**
 * The More tab. On a phone and an iPad upright, the three places in a list under the title; on the iPad on its side the
 * list is at the left and the six settings pages are in the main pane. A computer has no More in its top bar; opened by
 * its address it shows the upright page.
 */
export function MoreView() {
  const layout = useLayout();
  const lay: SeasonLayout = layout === "computer" ? "upright" : layout;

  if (lay === "side") {
    return (
      <Panes className="mo-split">
        <Pane kind="list" label="More">
          <div className="k-sp-lh">
            <div className="k-head">
              <h1 className="k-title">More</h1>
            </div>
          </div>
          <Page layout="side" className="mo">
            <MoreRows selected />
          </Page>
        </Pane>
        <Pane kind="main" label="Settings">
          <Page layout="side" className="mo mo-main">
            <div className="mo-ph">
              <h1 className="k-h1">Settings</h1>
            </div>
            <SettingsRows />
          </Page>
        </Pane>
      </Panes>
    );
  }

  return (
    <Page layout={lay} narrow className="mo mo-page">
      <PageHead title="More" right={lay === "phone" ? <FlashsuiteMenu compact /> : undefined} />
      <div className="mo-gap">
        <MoreRows />
      </div>
    </Page>
  );
}
